<div class="error-message">
  <h1>
    Ops!!! <br>
    Pagina non travata.
  </h1>
  <h3>Torna alla home</h3>
  <div class="home-button">
    <a [routerLink]="['/dashboard']">
      <button mat-icon-button >
        <mat-icon>home</mat-icon>
      </button>
    </a>
  </div>
</div>